import Vue from "vue";
import Router from "vue-router";
import HussarHomePage from "@/components/HussarHomePage";
import HussarHomePhonePage from "@/components/HussarHomePhonePage";
import ZeroCode from "@/components/ZeroCode";
import ZeroCodePhone from "@/components/ZeroCodePhone";
import LowCode from "@/components/LowCode";
import LowCodePhone from "@/components/LowCodePhone";
import FusionIntegration from "@/components/FusionIntegration";
import FusionIntegrationPhone from "@/components/FusionIntegrationPhone";
import UnifiedPortal from "@/components/UnifiedPortal";
import UnifiedPortalPhone from "@/components/UnifiedPortalPhone";
import UnifiedProcess from "@/components/UnifiedProcess";
import UnifiedProcessPhone from "@/components/UnifiedProcessPhone";
import KeyFeatures from "@/components/KeyFeatures";
import KeyFeaturesPhone from "@/components/KeyFeaturesPhone";
import AllProduct from "@/components/AllProduct";
import AllProductPhone from "@/components/AllProductPhone";
import CasePage from "../components/CasePage";
import CasePhonePage from "@/components/CasePhonePage";
import CasePageArticle from "../components/CasePageArticle";
import CasePhonePageArticle from "@/components/CasePhonePageArticle";
import FrontierPage from "../components/FrontierPage";
import FrontierPhonePage from "../components/FrontierPhonePage";
import FrontierDetailsArticle from "../components/FrontierDetailsArticle";
import FrontierDetailsPhoneArticle from "../components/FrontierDetailsPhoneArticle";
import FrontierSelectPage from "../components/FrontierSelectPage";
import DocumentPage from "../components/DocumentPage";
import DocumentPhonePage from "../components/DocumentPhonePage";
import MallPage from "../components/MallPage";
import MallPhonePage from "../components/MallPhonePage";

Vue.use(Router);

// 打开相同路由报错修复
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: "/",
    name: "HussarHomePage",
    component: HussarHomePage,
    meta: {
      title: "轻骑兵低代码开发平台_低代码平台开发_低代码让软件开发更简单|金现代",
      content: {
        keywords: "低代码开发，低代码，低代码开发平台，低代码平台，低代码可视化开发，低代码应用开发平台",
        description: "轻骑兵低代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/HussarHomePhonePage",
    name: "HussarHomePhonePage",
    component: HussarHomePhonePage,
    meta: {
      title: "轻骑兵低代码开发平台_低代码平台开发_低代码让软件开发更简单|金现代",
      content: {
        keywords: "低代码开发，低代码，低代码开发平台，低代码平台，低代码可视化开发，低代码应用开发平台",
        description: "轻骑兵低代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/nocode",
    name: "ZeroCode",
    component: ZeroCode,
    meta: {
      title: "轻骑兵零代码开发平台_零代码平台开发_零代码让软件开发更简单|金现代",
      content: {
        keywords: "零代码开发，零代码，零代码开发平台，零代码平台，零代码可视化开发，零代码应用开发平台",
        description: "轻骑兵零代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/nocodephone",
    name: "ZeroCodePhone",
    component: ZeroCodePhone,
    meta: {
      title: "轻骑兵零代码开发平台_零代码平台开发_零代码让软件开发更简单|金现代",
      content: {
        keywords: "零代码开发，零代码，零代码开发平台，零代码平台，零代码可视化开发，零代码应用开发平台",
        description: "轻骑兵零代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/lowcode",
    name: "LowCode",
    component: LowCode,
    meta: {
      title: "轻骑兵低代码开发平台_低代码平台开发_低代码让软件开发更简单|金现代",
      content: {
        keywords: "低代码开发，低代码，低代码开发平台，低代码平台，低代码可视化开发，低代码应用开发平台",
        description: "轻骑兵低代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/lowcodephone",
    name: "LowCodePhone",
    component: LowCodePhone,
    meta: {
      title: "轻骑兵低代码开发平台_低代码平台开发_低代码让软件开发更简单|金现代",
      content: {
        keywords: "低代码开发，低代码，低代码开发平台，低代码平台，低代码可视化开发，低代码应用开发平台",
        description: "轻骑兵低代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/apaas",
    name: "FusionIntegration",
    component: FusionIntegration,
    meta: {
      title: "融合集成|金现代",
      content: {
        keywords: "融合集成",
        description: "融合集成"
      }
    }
  },
  {
    path: "/apaasphone",
    name: "FusionIntegrationPhone",
    component: FusionIntegrationPhone,
    meta: {
      title: "融合集成|金现代",
      content: {
        keywords: "融合集成",
        description: "融合集成"
      }
    }
  },
  {
    path: "/portal",
    name: "UnifiedPortal",
    component: UnifiedPortal,
    meta: {
      title: "统一门户|金现代",
      content: {
        keywords: "统一门户",
        description: "统一门户"
      }
    }
  },
  {
    path: "/portalphone",
    name: "UnifiedPortalPhone",
    component: UnifiedPortalPhone,
    meta: {
      title:
        "统一门户|金现代",
      content: {
        keywords: "统一门户",
        description: "统一门户"
      }
    }
  },
  {
    path: "/bpm",
    name: "UnifiedProcess",
    component: UnifiedProcess,
    meta: {
      title: "工作流平台|金现代",
      content: {
        keywords: "工作流平台",
        description: "工作流平台"
      }
    }
  },
  {
    path: "/bpmphone",
    name: "UnifiedProcessPhone",
    component: UnifiedProcessPhone,
    meta: {
      title: "工作流平台|金现代",
      content: {
        keywords: "工作流平台",
        description: "工作流平台"
      }
    }
  },
  {
    path: "/keyfeatures",
    name: "KeyFeatures",
    component: KeyFeatures,
    meta: {
      title: "关键特征|金现代",
      content: {
        keywords: "关键特征",
        description: "关键特征"
      }
    }
  },
  {
    path: "/keyfeaturesphone",
    name: "KeyFeaturesPhone",
    component: KeyFeaturesPhone,
    meta: {
      title: "关键特征|金现代",
      content: {
        keywords: "关键特征",
        description: "关键特征"
      }
    }
  },
  {
    path: "/allproduct",
    name: "AllProduct",
    component: AllProduct,
    meta: {
      title: "所有产品|金现代",
      content: {
        keywords: "所有产品",
        description: "所有产品"
      }
    }
  },
  {
    path: "/allproductphone",
    name: "AllProductPhone",
    component: AllProductPhone,
    meta: {
      title: "所有产品|金现代",
      content: {
        keywords: "所有产品",
        description: "所有产品"
      }
    }
  },
  {
    path: "/CasePhonePage",
    name: "CasePhonePage",
    component: CasePhonePage,
    meta: {
      title: "轻骑兵低代码开发平台_低代码平台开发_低代码让软件开发更简单|金现代",
      content: {
        keywords: "低代码开发，低代码，低代码开发平台，低代码平台，低代码可视化开发，低代码应用开发平台",
        description: "轻骑兵低代码开发平台支持拖拉拽+少量配置的开发方式，提供多种二次开发方式，为复杂业务场景的开发提供支撑，是企业数字化转型的底座"
      }
    }
  },
  {
    path: "/CasePage",
    name: "CasePage",
    component: CasePage,
    meta: {
      title: "轻骑兵低代码开发平台案例_低代码厂商_低代码平台报价_低代码解决方案|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码平台，低代码案例，券商低代码，低代码方案，低代码报价",
        description: "金现代轻骑兵低代码开发平台客户案例包含航天科工集团、华能集团、中铁电气化局、中泰证券、国元证券等行业头部企业，助力千行百业成功交付万余应用，加速数字化转型"
      }
    }
  },
  {
    path: "/CasePage/CasePageArticle",
    name: "CasePageArticle",
    component: CasePageArticle,
    meta: {
      title: "轻骑兵低代码开发平台案例_低代码厂商_低代码平台报价_低代码解决方案|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码平台，低代码案例，券商低代码，低代码方案，低代码报价",
        description: "金现代轻骑兵低代码开发平台客户案例包含航天科工集团、华能集团、中铁电气化局、中泰证券、国元证券等行业头部企业，助力千行百业成功交付万余应用，加速数字化转型"
      }
    }
  },
  {
    path: "/CasePhonePage/CasePhonePageArticle",
    name: "CasePhonePageArticle",
    component: CasePhonePageArticle,
    meta: {
      title: "轻骑兵低代码开发平台案例_低代码厂商_低代码平台报价_低代码解决方案|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码平台，低代码案例，券商低代码，低代码方案，低代码报价",
        description: "金现代轻骑兵低代码开发平台客户案例包含航天科工集团、华能集团、中铁电气化局、中泰证券、国元证券等行业头部企业，助力千行百业成功交付万余应用，加速数字化转型"
      }
    }
  },
  {
    path: "/FrontierPage",
    name: "FrontierPage",
    component: FrontierPage,
    meta: {
      title: "低代码行业动态_低代码技术_低代码开发_可视化开发工具｜轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发技术，低代码工具，低代码相关政策，低代码市场前景",
        description: "金现代轻骑兵低代码开发平台可视化开发体验好，安全性高，灵活易扩展，还原性高，资质齐全，POC验证优势明显，是众多中大型企业的数字化提质增效的最佳选择"
      }
    }
  },

  {
    path: "/FrontierPhonePage",
    name: "FrontierPhonePage",
    component: FrontierPhonePage,
    meta: {
      title: "低代码行业动态_低代码技术_低代码开发_可视化开发工具｜轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发技术，低代码工具，低代码相关政策，低代码市场前景",
        description: "金现代轻骑兵低代码开发平台可视化开发体验好，安全性高，灵活易扩展，还原性高，资质齐全，POC验证优势明显，是众多中大型企业的数字化提质增效的最佳选择"
      }
    }
  },
  {
    path: "/FrontierPage/aboutArticle=:timestamp",
    name: "FrontierSelectPage",
    component: FrontierSelectPage,
    meta: {
      title: "低代码行业动态_低代码技术_低代码开发_可视化开发工具｜轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发技术，低代码工具，低代码相关政策，低代码市场前景",
        description: "金现代轻骑兵低代码开发平台可视化开发体验好，安全性高，灵活易扩展，还原性高，资质齐全，POC验证优势明显，是众多中大型企业的数字化提质增效的最佳选择"
      }
    }
  },
  {
    path: "/FrontierPage/detailsArticle=:timestamp",
    name: "FrontierDetailsArticle",
    component: FrontierDetailsArticle,
    meta: {
      title: "低代码行业动态_低代码技术_低代码开发_可视化开发工具｜轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发技术，低代码工具，低代码相关政策，低代码市场前景",
        description: "金现代轻骑兵低代码开发平台可视化开发体验好，安全性高，灵活易扩展，还原性高，资质齐全，POC验证优势明显，是众多中大型企业的数字化提质增效的最佳选择"
      }
    }
  },
  {
    path: "/FrontierPhonePage/detailsArticle",
    name: "FrontierDetailsPhoneArticle",
    component: FrontierDetailsPhoneArticle,
    meta: {
      title: "低代码行业动态_低代码技术_低代码开发_可视化开发工具｜轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发技术，低代码工具，低代码相关政策，低代码市场前景",
        description: "金现代轻骑兵低代码开发平台可视化开发体验好，安全性高，灵活易扩展，还原性高，资质齐全，POC验证优势明显，是众多中大型企业的数字化提质增效的最佳选择"
      }
    }
  },
  {
    path: "/DocumentPage",
    name: "DocumentPage",
    component: DocumentPage,
    meta: {
      title: "轻骑兵低代码开发平台白皮书_低代码行业研究报告_低代码平台排名|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码行业白皮书，金融低代码，智能制造低代码，人工智能低代码，低代码标准",
        description: "使用轻骑兵，只需编写少量代码(低代码)或无需编码 (零代码)，就可以快速生成软件产品，快速响应用户对数字化系统的各种要求，减少对技术人员的依赖，降低开发成本，缩短软件开发周期，提高企业数字化转型速度"
      }
    }
  },
  {
    path: "/DocumentPhonePage",
    name: "DocumentPhonePage",
    component: DocumentPhonePage,
    meta: {
      title: "轻骑兵低代码开发平台白皮书_低代码行业研究报告_低代码平台排名|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码行业白皮书，金融低代码，智能制造低代码，人工智能低代码，低代码标准",
        description: "使用轻骑兵，只需编写少量代码(低代码)或无需编码 (零代码)，就可以快速生成软件产品，快速响应用户对数字化系统的各种要求，减少对技术人员的依赖，降低开发成本，缩短软件开发周期，提高企业数字化转型速度"
      }
    }
  },
  {
    path: "/MallPage",
    name: "MallPage",
    component: MallPage,
    meta: {
      title: "轻骑兵低代码应用商城_低代码开发工具_低代码应用程序开发|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发平台，低代码快速开发，拖拉拽开发，可视化开发，小程序开发",
        description: "每天都有基于轻骑兵开发的应用上线，包括干部管理系统、智能运维管理系统、实验室管理系统等覆盖各行业、各场景的应用"
      }
    }
  },
  {
    path: "/MallPhonePage",
    name: "MallPhonePage",
    component: MallPhonePage,
    meta: {
      title: "轻骑兵低代码应用商城_低代码开发工具_低代码应用程序开发|轻骑兵低代码开发平台",
      content: {
        keywords: "低代码开发平台，低代码快速开发，拖拉拽开发，可视化开发，小程序开发",
        description: "每天都有基于轻骑兵开发的应用上线，包括干部管理系统、智能运维管理系统、实验室管理系统等覆盖各行业、各场景的应用"
      }
    }
  }
];

const router = new Router({
  mode: 'history',
  routes
});

// 不同页面使用不同TDK
router.beforeEach((to, from, next) => {
  // 路由发生变化改变description和keyword
  if (to.meta.content) {
    const head = document.getElementsByTagName("head");
    const meta = document.createElement("meta");
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", to.meta.content.keywords);
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.content.description);
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js